module.exports = __webpack_public_path__ + "static/img/login-bg.a88522c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg.jpg
// module id = kDKx
// module chunks = 1